document.addEventListener('DOMContentLoaded', (event) => {
    // Get all elements with the specific class 'mode-switch'
    let buttons = document.querySelectorAll('a.mode-switch');

    if (buttons) {
        // Add a click event listener to each button
        buttons.forEach(function(button) {
            button.addEventListener('click', function(e) {
                // if user click on same mode thats active
                if (location.hash != e.target.hash){
                    changeMode(e.target.hash);
                }

            });
        });

        function changeMode(setMode) {
            location.hash = setMode;

            setMode = setMode.replace('#', "");
            removeMode = (setMode == "overview") ? 'expert-mode' : 'overview';
            
            document.getElementById(removeMode + '-toggle').classList.remove('active');
            document.getElementById(setMode + '-toggle').classList.add('active');
            document.documentElement.classList.remove(removeMode);
            document.documentElement.classList.add(setMode);
        };
    }
});